<template>
  <div class="overall-bg header-top">
    <ApprovalConfirmation v-if="ApprovalListchange.length != 0 &&
      ApprovalListchange.some(item => item['IsApproved'] == 0)
    " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
      @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" />
    <ApprovalStatus v-if="ApprovalList.length != 0" :ApprovalgetList="ApprovalList"
      :approvaldetails="approvaldetails" />
    <b-container class="overall-bg pb-0">
      <b-row>
        <b-col>
          <BacktoPage :goback="$router.back"></BacktoPage>
          <b-row>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <!-- {{ data }} -->
    <section v-if="items.length !== 0" class="">

      <DetailsBanner :details="data" :loading="loading" class="my-4" />

    </section>
    <b-container class="form-white-bg">
      <div class='field' v-if="uploadedTableList.length != 0">
        <label class=" mb-0">{{ $t("PurchaseRequest.QuotationFile") }}</label>
      </div>
      <b-row>
        <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
          <div class="fileuploadcard my-2" :title="item.fileName">
            <div>
              <p class="filenametxt">{{ item.fileName }}</p>
              <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                view </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-between align-items-center">
        <p class="common-heading1 mb-4">Items part of the request</p>
        <div>
          <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
        </div>
      </div>
      <TabView class="tabview-custom" ref="tabview4">

        <TabPanel>
          <template #header>
            <i class="pi pi-file-edit pe-3"></i>
            <span>Request Details
              <Badge :value="items.length" severity="warning"></Badge>
            </span>
          </template>

          <b-row class="mt-2" v-if="ObjCamp.IsCamp && ObjCamp.CampDetailCard">
            <p class="fn14 fw500">Camp Details</p>
            <b-col lg="6" md="6" class="campdetailscard">
              <b-row>
                <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Institute name:</p>
                  <p class="fn14 fw500">{{ ObjCamp.InstituteName }}</p>
                </b-col>
                <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Camp date:</p>
                  <p class="fn14 fw500">{{ ObjCamp.FormattedCampDate }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="8" md="8" class="d-flex align-items-center gap-2 py-2">
                  <p class="light-txt">Camp type:</p>
                  <p class="fn14 fw500">{{ ObjCamp.CampType }}</p>
                </b-col>
                <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Expected IP:</p>
                  <p class="fn14 fw500">{{ ObjCamp.ExpectedIP }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Camp name:</p>
                  <p class="fn14 fw500">{{ ObjCamp.CampName }}</p>
                </b-col>
                <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Expected OP:</p>
                  <p class="fn14 fw500">{{ ObjCamp.ExpectedOP }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div v-if="windowWidth > 545">

            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0" eheader="InBound Request Items" econtent="InBound Request Items"
                eimg="/src/assets/Img/icons/request.svg" @createNew="" :createline="false" />
            </div>
            <Tableview v-if="items.length !== 0" v-model:value="items" :paginator="true" class="p-datatable-gridlines"
              :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
              :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" :seriaNlumber="true">
              <template v-slot:Add>

              </template>
              <template v-slot:Brandmodelsize="{ data }">
                <p v-if="data.BrandName == null && data.ModelNumberName == null && data.SizeName == null">
                  {{ "-" }}
                </p>
                <p v-else>
                  {{ data.BrandName != null ? data.BrandName : "-" }} /
                  {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }} /
                  {{ data.SizeName != null ? data.SizeName : "-" }}
                </P>
              </template>
              <template v-slot:StockInHandSlot="{ data }">
                {{
                  data.StockInHand - (data.PickedQty + data.InTransist)
                }}
              </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsConfirmEdit(data)" />
                  <DeleteIcon @click="IsConfirmDel(data)" />
                </span>
              </template>
              <template v-slot:PRStatusType="{ data }">
                <OrangeStatus name="Pending" v-if="data.PRStatusType == 0" />
                <GreenStatus name="Issued" v-if="data.PRStatusType == 1" />
                <BlueStatus name="Partially Issued" v-if="data.PRStatusType == 2" />
                <BlueStatus name="Converted To PR" v-if="data.PRStatusType == 3" />
                <BlueStatus name="Converted To PR Partially" v-if="data.PRStatusType == 4" />
              </template>
            </Tableview>


            <b-row>
              <b-col offset-lg="3" class="d-flex px-0 justify-content-end">
                <div class="totaldiv1">
                  <p class="component-heading">{{ POCalcDetails.ItemCount }}</p>

                  <p class="light-txt">Items Part of this request</p>
                </div>
                <div class="totaldiv2">
                  <p class="component-heading"><span class="pe-1">&#8377</span>{{ POCalcDetails.TotalAmount }}
                  </p>
                  <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                </div>
              </b-col>
            </b-row>

          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0" eheader="InBound Request Items" econtent="InBound Request Items"
                eimg="/src/assets/Img/icons/request.svg" @createNew="" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items">
                    <div class="d-flex align-items-center gap-1">
                      <p class="light-name">{{ item["ItemCode"] }} /</p>
                      <p class="light-name">{{ item["HSNCode"] }}</p>
                      <p class="light-name" v-if="item['IssueCode']">
                        / {{ item["IssueCode"] }}
                      </p>
                    </div>
                    <p class="name">{{ item["Itemname1"] }}</p>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Requested Quantity :</p>
                      <p class="small-name">
                        {{ item["ItemQuantity"] ? item["ItemQuantity"] : "0" }}
                      </p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Received Quantity :</p>
                      <p class="small-name">
                        {{ item["IssueQty"] ? item["IssueQty"] : "0" }}
                      </p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Returns :</p>
                      <p class="small-name">
                        {{ item["Returns"] ? item["Returns"] : "0" }}
                      </p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>

          <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
            :content="$t('confirmation.editcontent')" />
          <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
          <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
          <!-- </div> -->
        </TabPanel>
        <TabPanel>
          <template #header>
            <i class="pi pi-box pe-3"></i>
            <span>Issue Details
            </span>
          </template>
          <div v-if="windowWidth > 545">

            <SkeletonTableLoader :columns="IssueDetailsHeaders" :loading="IssueTableLoader" />
            <div v-if="!IssueTableLoader">
              <MasterEmpty v-if="issueDetailData.length === 0" eheader="Issue Details" econtent="Issue Details"
                eimg="/src/assets/Img/icons/request.svg" @createNew="" :createline="false" />
            </div>

            <Tableview v-if="issueDetailData.length !== 0" v-model:value="issueDetailData" :paginator="true"
              class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu"
              :loading="IssueTableLoader" responsiveLayout="scroll" :columns="IssueDetailsHeaders"
              :globalFilterFields="globalFilterFields" :filters="filters" :seriaNlumber="true">
              <template v-slot:Itemname1="{ data }">
                <span>
                  {{ data.Itemname1 }}
                </span>
                <span class="spantxt">
                  {{ data.BarCode }}
                </span>
              </template>
              <template v-slot:Brandmodelsize="{ data }">
                <p v-if="data.BrandName == null && data.ModelNumberName == null && data.SizeName == null">
                  {{ "-" }}
                </p>
                <p v-else>
                  {{ data.BrandName != null ? data.BrandName : "-" }} /
                  {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }} /
                  {{ data.SizeName != null ? data.SizeName : "-" }}
                </P>
              </template>
              <template v-slot:StockInHandSlot="{ data }">
                {{
                  data.StockInHand - (data.PickedQty + data.InTransist)
                }}
              </template>
            </Tableview>

          </div>
        </TabPanel>
        <TabPanel>
          <template #header>
            <i class="pi pi-history pe-3"></i>
            <span>Logs</span>
          </template>
          <div class="logcard">
            <Log />
          </div>
        </TabPanel>

      </TabView>
    </b-container>
  </div>

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted, computed, watch } from "vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/NormalTable.vue";
import Log from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import commonService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useRoute } from "vue-router";
import WithoutStockAffectService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useRouter } from "vue-router";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import RequestFlowChart from "../../../../../../../components/Chart/RequestFlowChart.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import DetailsBanner from "../../../../../../../modules/Inventory/components/Transaction/detailsbanner.vue"
import moment from "moment";
import ApprovalConfirmation from "../../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../../components/FormComponents/ApprovalStatus.vue";
import PoApprovalService from "../../../../../../../modules/Inventory/Service/PoApprovalService";
import { useI18n } from 'vue-i18n';
import StockWOFileUploadServices from "../../../../../../../modules/Inventory/Service/StockWOFileUploadService";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";


export default defineComponent({
  components: {
    BacktoPage,
    Tableview,
    Log,
    Loader,
    RequestFlowChart,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    DetailsBanner,
    ApprovalConfirmation,
    ApprovalStatus,
    TextField,
    CrystalReportPrintPopUp

  },
  setup() {
    let loading = ref(false);
    let IssueTableLoader = ref(false);
    const routes = useRoute();
    let stocktransid = routes.query.stocktransid;
    let status = routes.query.status ?? 0;
    const dataEdit = ref({});
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const router = useRouter();
    let requestid = ref("");
    const menu = ref();
    let items: any = ref([]);
    let issueDetailData: any = ref([]);

    const action = ref([
      {
        items: [
          {
            label: "Close the request",
          },

        ],
      },
    ]);


    let ObjCamp: any = ref(
      {
        CampDetailCard: false,
        IsCamp: false,
        CampId: ref(),
        InstituteName: "",
        CampName: "",
        CampType: "",
        CampDate: "",
        FormattedCampDate: "",
        ExpectedIP: "",
        ExpectedOP: "",
      }
    )

    let uploadedTableList: any = ref([])
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }
    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      RequesterName: "",
      RequestCategory: "",
      Remarks: "",
      MarkasUrgent: ref(),
      Status: "",

      ToStoreBranchId: 0,

      tostoreid: "",
      id: ref(),
      date: ref(),
      EntityId: 0
    });

    const POCalcDetails: any = ref({
      GrossAmount: 0.00,
      ItemCount: 0,
      TotalAmount: 0.00
    })

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t('storetabdetails.inboundrequestdetails.Category'),
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.Code'),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
        bodyclass: "boldclass",

      },
      {
        header: t('storetabdetails.inboundrequestdetails.Name'),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth newcolumnfreezeleft3"
      },
      {
        header: t('storetabdetails.outboundrequestdetails.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1",
        class: "newcolumnfreezeleft4"
      },
      // {
      //   header: t('storetabdetails.inboundrequestdetails.IssueId'),
      //   field: "IssueCode",
      //   class: "smallwidth newcolumnfreezeleft5"
      // },
      {
        header: t('storetabdetails.inboundrequestdetails.UOM'),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.ReqQty'),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth, "
      },
      {
        header: t('storetabdetails.inboundrequestdetails.IssuedQty'),
        field: "IssueQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.BalanceQty'),
        field: "availableQty",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.AvlQty'),
        field: "StockInHand",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "Picked Qty",
        field: "PickedQty",
        bodyclass: "right_td",
        class: "smallwidth"
      }, {
        header: "InTransist Qty",
        field: "InTransist",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.ToStoreAvlQty'),
        field: "ToStoreStockInHand",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.ReturnQty'),
        field: "ReturnQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.DeletedReason'),
        field: "DeletedReason",
        bodyclass: "boldclass right_td",
        class: "smallwidth"
      },
      {
        header: 'PRStatus',
        field: "PRStatusType",
        slot: "PRStatusType",
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },
    ];
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const IssueDetailsHeaders = [
      {
        header: t('storetabdetails.inboundrequestdetails.Category'),
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.Code'),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
        bodyclass: "boldclass",

      },
      {
        header: t('storetabdetails.inboundrequestdetails.Name'),
        field: "Itemname1",
        slot: "Itemname1",
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth newcolumnfreezeleft3"
      },
      {
        header: t('storetabdetails.outboundrequestdetails.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1",
        class: "newcolumnfreezeleft4"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.IssueId'),
        field: "IssueCode",
        class: "smallwidth newcolumnfreezeleft5"
      },

      {
        header: t('storetabdetails.inboundrequestdetails.UOM'),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      // {
      //   header: t('storetabdetails.inboundrequestdetails.ReqQty'),
      //   field: "ItemQuantity",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t('storetabdetails.inboundrequestdetails.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth, "
      },
      {
        header: t('storetabdetails.inboundrequestdetails.IssuedQty'),
        field: "IssueQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.AvlQty'),
        field: "StockInHand",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "Picked Qty",
        field: "PickedQty",
        bodyclass: "right_td",
        class: "smallwidth"
      }, {
        header: "InTransist Qty",
        field: "InTransist",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.ToStoreAvlQty'),
        field: "ToStoreStockInHand",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.inboundrequestdetails.ReturnQty'),
        field: "ReturnQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth"
      },

    ];

    onMounted(async () => {
      window.addEventListener("resize", handleResize);
      await IsShow();
      await LoadIssueDetails();
      await getApprovaldata();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    const toggle = (event: MouseEvent) => {
      menu.value.toggle(event);
    };

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }

    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }

    function IsEdit(data) {
      debugger;
      router.push({
        name: "Createstore",
        query: {
          storeId: data.Id,
          storeType: data.StoreTypeId,
        },
      });
    }

    async function IsDelete(data) { }

    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const result = await WithoutStockAffectService.GetByStockWOTransId(
          stocktransid
        );
        items.value = result["result"].map(obj => ({
          ...obj,
          UnitRate: obj.UnitRate.toFixed(2),
          Rate: obj.Rate.toFixed(2)

        }));
        items.value.sort((a, b) => {
          return a.Itemname1.localeCompare(b.Itemname1);
        });
        console.log(items.value);
        const totalIssueQty = computed(() => {
          return items.value.reduce((sum, item: any) => sum + item.IssueQty, 0);
        });

        const totalItemQty = computed(() => {
          return items.value.reduce((sum, item: any) => sum + item.ItemQuantity, 0);
        });
        requestid.value = result["result"][0].DocNo;
        data.value.fromstr = result["result"][0].FromStoreName;
        data.value.tostr = result["result"][0].ToStoreName;
        data.value.fromstoreid = result["result"][0].FromStoreCode;
        data.value.tostoreid = result["result"][0].ToStoreCode;
        data.value.fromstatus = result["result"][0].FromStoreType;
        data.value.tostatus = result["result"][0].ToStoreType;
        data.value.EntityId = result["result"][0].EntityId;

        data.value.Remarks = result["result"][0].Remarks;
        data.value.RequestCategory = result["result"][0].CategoryName;
        data.value.RequesterName = result["result"][0].CreatedByName;
        data.value.MarkasUrgent = result["result"][0].Remarkscheck == 1 ? true : false;

        data.value.ToStoreBranchId = result["result"][0].ToStoreBranchId;

        // data.value.fromcount = 0;
        // data.value.tocount = items.value.length;
        data.value.fromcount = totalItemQty;
        data.value.tocount = totalIssueQty;
        data.value.id = result["result"][0].DocNo;

        data.value.Status = result["result"][0].Status;

        data.value.date = moment(result["result"][0].DocDate).format("DD-MM-YYYY");
        items.value = items.value.map((item) => {
          const availableQty = item['ItemQuantity'] - item['IssueQty'];
          item['availableQty'] = availableQty;
          return item;
        });


        if (result["result"][0].IsCamp) {
          ObjCamp.value.IsCamp = result["result"][0].IsCamp;
          ObjCamp.value.CampId = result["result"][0].CampId;
          ObjCamp.value.InstituteName = result["result"][0].InstituteName;
          ObjCamp.value.CampName = result["result"][0].CampName;
          ObjCamp.value.CampType = result["result"][0].CampType;
          ObjCamp.value.CampDate = result["result"][0].CampDate;
          ObjCamp.value.FormattedCampDate = moment(
            result["result"][0].CampDate,
            "MM/DD/YYYY hh:mm:ss A"
          ).format("DD/MM/YYYY"); ObjCamp.value.ExpectedIP = result["result"][0].ExpectedIP;
          ObjCamp.value.ExpectedOP = result["result"][0].ExpectedOP;
          ObjCamp.value.CampDetailCard = true;
        }

        const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
          stocktransid
        );
        if (FileUploadresult['result'].length > 0) {
          for (let i = 0; i < FileUploadresult['result'].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
              (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
              (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
              (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
              (Fileobj["Id"] = FileUploadresult['result'][i].Id),
              uploadedTableList.value.push(Fileobj)
          }
        }
        else {
          uploadedTableList.value = [];
        }
        loading.value = false;
      } catch (error) { console.log(error); loading.value = false; }
    }

    async function LoadIssueDetails() {
      debugger;
      try {
        IssueTableLoader.value = true;
        const result = await WithoutStockAffectService.GetIssueDetailsByRequestId(
          stocktransid
        );

        issueDetailData.value = result["result"];

        IssueTableLoader.value = false;
      } catch (error) { console.log(error); IssueTableLoader.value = false; }
    }

    watch(items, (newItems, oldItems) => {
      debugger;
      pocalculation();
    }, { deep: true });

    const pocalculation = () => {
      debugger;
      POCalcDetailsClear()
      for (let i = 0; i < items.value.length; i++) {
        POCalcDetails.value.GrossAmount += parseFloat(items.value[i]["Rate"]);
      }
      poSubcalculation()
    };

    const poSubcalculation = () => {
      debugger;
      POCalcDetails.value.ItemCount = items.value.length;
      POCalcDetails.value.TotalAmount = Number(POCalcDetails.value.GrossAmount).toFixed(2);
    }

    function POCalcDetailsClear() {
      debugger;
      POCalcDetails.value.GrossAmount = 0.00;
      POCalcDetails.value.ItemCount = 0;
      POCalcDetails.value.TotalAmount = 0.00;
    }
    let ApprovalList = ref([]);

    let ApprovalListchange = ref([]);
    let approvaldetails: any = ref({
      HeaderName: "Inbound Request",
      ContentName: "Inbound Request",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "00:00:00",
    });

    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let HospitalId = Number(usersData.OrganizationId);
    let BranchId = Number(usersData.BranchId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    let DeptRoleMapId = Number(rolesData.DeptRoleMapId);

    async function getApprovaldata() {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          stocktransid,
          usersData.OrganizationId,
          usersData.BranchId,
          data.value.EntityId
        );
        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == DeptRoleMapId
        );
        console.log("approval data", ApprovalList.value);
      } catch (error) {
        console.log(error);
      }
    }

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0
    });

    async function Approve(Values) {
      debugger;
      try {
        let rowToAssign = null;
        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }
        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];
          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = data.value.EntityId;
        }
        let response;
        if (isForm.value.IsApproved == 1) {
          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1) {
              UpdateApprovalStatus();
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus();
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function UpdateApprovalStatus() {
      debugger;
      try {
        const response = await commonService.UpdateApprovalStatus(
          ApprovalListchange.value[0]["EntityTransactionId"],
          isForm.value.IsApproved
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    }

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
      HospitalId: 0,
      BranchId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 9,
      HeaderTitle: "InBound Request",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = stocktransid;
      ParameterValues.value.BranchId = data.value.ToStoreBranchId;
      ParameterValues.value.HospitalId = usersData.OrganizationId;

    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      data,
      action,
      toggle,
      menu,
      globalFilterFields,
      items,
      issueDetailData,
      headers,
      IssueDetailsHeaders,
      filters,
      loading,
      IssueTableLoader,
      IsShow,
      IsConfirmEdit,
      dataEdit,
      Editmodel,
      deletepop,
      IsConfirmDel,
      closetrigger,
      IsEdit,
      Deletemodel,
      IsDelete,
      requestid,
      windowWidth,
      POCalcDetails,
      ApprovalListchange,
      approvaldetails,
      SuccessfullPopUp,
      ApprovalList,
      getApprovaldata,
      Approve,
      fileviewer,
      uploadedTableList,
      ObjCamp,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Print
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-icon {
  width: 30px;
}

.blackbg {
  background-color: #303030;
  height: 150px;
}

.Actionsbtn {
  background-color: #0a82ff !important;
  border: none !important;
  padding: 8px !important;
}

.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

// .itempart {}

// .logcard {
//     height: 30px;
// }</style>
